import { render, staticRenderFns } from "./ksgl-app.vue?vue&type=template&id=73bebce4&scoped=true"
import script from "./ksgl-app.vue?vue&type=script&lang=js"
export * from "./ksgl-app.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/base.css?vue&type=style&index=0&id=73bebce4&prod&scoped=true&lang=css&external"
import style1 from "./ksgl-app.vue?vue&type=style&index=1&id=73bebce4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bebce4",
  null
  
)

export default component.exports